/** Табы **/

const $tabs = $('.js-tabs');

if ($tabs.length) {
    $tabs.each(function (index, el) {
        const $currTab = $(el);
        const $currTitles = $currTab.find('.js-ajax-tab-item');
        const $currContent = $currTab.find('.js-tab-content');

        $currTitles.each(function (elIndex, elTitle) {
            $(elTitle).data('index', elIndex);
            $currContent.eq(elIndex).data('index', elIndex);
        });
    });

    $('.js-ajax-tab-item').on('click', function (e) {
        const $currAjaxTabItem = $(this);
        const $currTabs = $currAjaxTabItem.closest('.js-tabs');
        const ajaxTab = $currTabs.is('[data-ajax]');
        const currIndex = $currAjaxTabItem.data('index');
        const $currTabContent = $currTabs.find('.js-tab-content');
        const $currTabTitles = $currTabs.find('.js-ajax-tab-item');

        $currTabTitles.removeClass('_active');
        $currAjaxTabItem.addClass('_active');

        if (ajaxTab) {
            if ($currTabContent.eq(currIndex).is('._loaded')) {
                $currTabContent.hide();
                $currTabContent.eq(currIndex).show();
            } else {
                loadAjaxTab($currAjaxTabItem.attr('href'), $currTabContent, currIndex);
            }

            if (window.history) {
                history.pushState({param: 'Value'}, '', $currAjaxTabItem.attr('href'));
            }
        } else {
            $currTabContent.hide().eq(currIndex).show();
        }

        e.preventDefault();
    });
}

function loadAjaxTab(href, tabs, index, ajaxType) {
    tabs.hide();

    $.ajax({
        url: href,
        data: '',
        type: ajaxType || 'GET',
        cache: false,
        success: (response) => {
            if (response) {
                tabs.eq(index).addClass('_loaded').show().html($(response).find('.js-tab-content').html());
                App.H.removeClass('_loading');
            } else {
                console.log('Ошибка получения данных');
            }

            App.H.removeClass('_loading');
        },
        error: () => {
            console.log('Ошибка загрузки отчетов');
            App.H.removeClass('_loading');
        }
    });
}


// WEBPACK FOOTER //
// ./_src/js/Tabs.js